import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_d3847237-0083-4d9a-8894-4d2f16e30b2b/artifacts/sdezziti_Logo%20CIBS%20Trasparente.png";

const CLIENT_KEY = "das_client";

export function getStoredClient() {
  try { return JSON.parse(sessionStorage.getItem(CLIENT_KEY)); } catch { return null; }
}
export function setStoredClient(c) {
  if (c) sessionStorage.setItem(CLIENT_KEY, JSON.stringify(c));
  else sessionStorage.removeItem(CLIENT_KEY);
}
export function logoSrc(client) {
  const src = client?.logo_src;
  if (!src) return null;
  return src.startsWith("/api") ? `${BACKEND_URL}${src}` : src;
}

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cibs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("cibs_token");
      localStorage.removeItem("cibs_user");
      const p = window.location.pathname;
      if (p !== "/" && !p.startsWith("/login") && !p.startsWith("/superadmin/login")) {
        window.location.href = p.startsWith("/superadmin") ? "/superadmin/login" : "/";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(", ");
  if (typeof detail?.msg === "string") return detail.msg;
  return JSON.stringify(detail);
}

export async function downloadFile(path, fallbackFilename) {
  const response = await api.get(path, { responseType: "blob" });
  // Try to extract filename from Content-Disposition
  let filename = fallbackFilename;
  const cd = response.headers["content-disposition"];
  if (cd) {
    const m = /filename="?([^";]+)"?/i.exec(cd);
    if (m) filename = m[1];
  }
  const blob = new Blob([response.data], { type: response.data.type || "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default api;
